import { Badge } from "@/components/ui/badge";
import { AlertTriangle, Grid3x3 } from "lucide-react";

export function SearchStatsPanel({ search }) {
  if (!search) return null;
  const { stats, cost_log, ville_resolue } = search;

  return (
    <div className="border border-border" data-testid="search-stats-panel">
      <div className="grid grid-cols-2 md:grid-cols-4 divide-y md:divide-y-0 divide-x-0 md:divide-x divide-border border-b border-border">
        <StatBlock label="Resultats bruts" value={stats.nb_resultats_bruts} testId="stat-bruts" />
        <StatBlock label="Apres dedup" value={stats.nb_apres_dedup} testId="stat-dedup" />
        <StatBlock label="Sans site Google" value={stats.nb_sans_site} testId="stat-sans-site" accent />
        <StatBlock label="Apres filtres" value={stats.nb_apres_filtres} testId="stat-filtres" />
      </div>
      <div className="flex flex-wrap items-center gap-2 p-4">
        {stats.zone_decoupee && (
          <Badge
            data-testid="badge-zone-decoupee"
            className="rounded-none font-mono text-xs uppercase tracking-wider gap-1 bg-secondary text-secondary-foreground border border-border"
          >
            <Grid3x3 size={12} /> Recherche decoupee ({stats.nb_tuiles} zones)
          </Badge>
        )}
        {stats.recherche_partielle && (
          <Badge
            data-testid="badge-recherche-partielle"
            className="rounded-none font-mono text-xs uppercase tracking-wider gap-1 bg-[hsl(var(--warning))] text-black border-transparent"
          >
            <AlertTriangle size={12} /> Recherche partielle{stats.raison_partielle ? ` - ${stats.raison_partielle}` : ""}
          </Badge>
        )}
        <span className="font-mono text-xs text-muted-foreground ml-auto" data-testid="cost-log-info">
          {cost_log.requetes_effectuees} requetes API - ~${cost_log.cout_estime_usd.toFixed(3)} - {cost_log.duree_ms}ms
          {ville_resolue ? ` - Ville resolue: ${ville_resolue}` : ""}
        </span>
      </div>
      <div className="px-4 pb-4">
        <p className="font-mono text-xs text-muted-foreground border-t border-border pt-3" data-testid="disclaimer-text">
          "Sans site web" = aucun site renseigne sur Google Places. Cela ne garantit pas l'absence reelle d'un site.
        </p>
      </div>
    </div>
  );
}

function StatBlock({ label, value, testId, accent }) {
  return (
    <div className="p-4" data-testid={testId}>
      <p className="font-mono text-xs uppercase tracking-wider text-muted-foreground mb-1">{label}</p>
      <p className={`font-heading text-3xl font-black tracking-tighter ${accent ? "text-[hsl(var(--destructive))]" : ""}`}>{value}</p>
    </div>
  );
}
